import { ReactElement, ReactNode } from "react";
import { Text } from "@mantine/core";
import { AddOnCard } from "@addons/components/AddOnCard";
import { EarlyAccessBadge } from "@components/ui/plan/EarlyAccessBadge/EarlyAccessBadge";
import { IAddOnSlotProps } from "../../types";

interface ITrackCardProps extends IAddOnSlotProps {
  /** the enable/disable link, or the read-only "Enabled" text */
  action: ReactNode;
  disabled: boolean;
  /** paid only, and only while unsubscribed */
  pricingLine?: ReactNode;
  usage: ReactNode;
}

/** everything the two Metabase Track variants render identically */
export function TrackCard({
  addOn: { productType, isYearly, title },
  action,
  disabled,
  pricingLine,
  usage,
}: ITrackCardProps): ReactElement {
  return (
    <AddOnCard
      isYearly={isYearly}
      productType={productType}
      title={title}
      badge={<EarlyAccessBadge ml="xs" />}
      disabled={disabled}
      extra={action}
      description={
        <>
          Capture user events like page views, clicks, and API calls.
          {pricingLine && (
            <Text c="gray.4" size="sm" maw={660} mt="xs">
              {pricingLine}
            </Text>
          )}
        </>
      }
      usage={usage}
    />
  );
}
